<template>
  <div><div class="breadcrumb-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-6">
          <div class="page-title">
            <h2>购物车</h2>
          </div>
        </div>
        <div class="col-sm-6">
          <nav aria-label="breadcrumb" class="theme-breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">主页</a></li>
              <li class="breadcrumb-item active" aria-current="page">购物车</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
    <section class="cart-section section-b-space">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 table-responsive-xs">
            <table class="table cart-table">
              <thead>
              <tr class="table-head">
                <th scope="col">图片</th>
                <th scope="col">产品名</th>
                <th scope="col">价格</th>
                <th scope="col">数量</th>
                <th scope="col">操作</th>
                <th scope="col">小计</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(goods, i) in cart" :key="goods.plan.plan_id">
                <td>
                  <a href="#">
                    <img :src="goods.pic" alt="">
                  </a>
                </td>
                <td>
                  <a href="#">{{ goods.plan.name }}</a>
                  <p href="#">服务{{ goods.service.name }}</p>
                  <div class="mobile-cart-content row">
                    <div class="col">
                      <div class="qty-box">
                        <div class="input-group">
                          <a-input-number v-model="goods.qty" style="width: 50px;" @change="getCartTotal"/>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <h2 class="td-color">￥{{ (goods.plan.price + goods.service.price) | number('0,0') }}</h2>
                    </div>
                    <div class="col">
                      <h2 class="td-color">
                        <a href="#" class="icon" @click="removeCart(i)">
                          <i class="ti-close"></i>
                        </a>
                      </h2>
                    </div>
                  </div>
                </td>
                <td>
                  <h2>￥{{ (goods.plan.price + goods.service.price) | number('0,0') }}</h2>
                </td>
                <td>
                  <div class="qty-box">
                    <div class="input-group">
                      <a-input-number v-model="goods.qty" style="width: 50px;" @change="getCartTotal"/>
                    </div>
                  </div>
                </td>
                <td>
                  <a href="#" class="icon" @click="removeCart(i)">
                    <i class="ti-close"></i>
                  </a>
                </td>
                <td>
                  <h2 class="td-color">￥{{ (goods.plan.price + goods.service.price) * goods.qty | number('0,0') }}</h2>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="table-responsive-md">
              <table class="table cart-table ">
                <tfoot>
                <tr>
                  <td>合计 :</td>
                  <td>
                    <h2>￥{{ total | number('0,0') }}</h2>
                  </td>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <div class="row cart-buttons">
          <div class="col-6"></div>
          <div class="col-6"><a href="/#/checkout" class="btn btn-solid">开始结算</a></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getCart, setCart } from '@/libs/util'

export default {
  name: 'Cart',
  data () {
    return {
      cart: [],
      total: 0
    }
  },
  methods: {
    getCart () {
      this.cart = getCart()
    },
    getCartTotal () {
      this.total = 0
      this.cart.forEach(v => {
        if (v.qty < 1) {
          v.qty = 1
        }
        this.total += (v.plan.price + v.service.price) * v.qty
      })
      setCart(this.cart)
    },
    removeCart (i) {
      this.cart.splice(i, 1)
    }
  },
  mounted () {
    this.getCart()
    this.$parent.cart = this.cart
  },
  watch: {
    cart: {
      handler (newValue, oldVaule) {
        this.getCartTotal()
        this.$parent.cart = this.cart
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cart.vue